import { Component, inject } from '@angular/core';
import { SpeciesGroupChipCubicMeterCoefficientService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpeciesGroupChipCubicMeterCoefficientCreateDto,
  SpeciesGroupChipCubicMeterCoefficientDto,
  SpeciesGroupChipCubicMeterCoefficientExcelDownloadDto,
  SpeciesGroupChipCubicMeterCoefficientUpdateDto,
} from '../proxy/general/dtos/species-group-chip-cubic-meter-coefficient';
import { SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG, SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_FIELDS } from './species-group-chip-cubic-meter-coefficient.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-species-group-chip-cubic-meter-coefficient',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpeciesGroupChipCubicMeterCoefficientService, ConfirmationService],
  templateUrl: './species-group-chip-cubic-meter-coefficient.html',
  styleUrl: './species-group-chip-cubic-meter-coefficient.scss',
})
export class SpeciesGroupChipCubicMeterCoefficient extends BaseCrudComponent<
  SpeciesGroupChipCubicMeterCoefficientDto,
  SpeciesGroupChipCubicMeterCoefficientCreateDto,
  SpeciesGroupChipCubicMeterCoefficientUpdateDto,
  SpeciesGroupChipCubicMeterCoefficientExcelDownloadDto
> {
  service = inject(SpeciesGroupChipCubicMeterCoefficientService);
  config = SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG;
  fields = SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpeciesGroupChipCubicMeterCoefficientDto): SpeciesGroupChipCubicMeterCoefficientUpdateDto {
    return {
      coefficientValue: data.coefficientValue,
      validSince: data.validSince,
      speciesGroupId: data.speciesGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpeciesGroupChipCubicMeterCoefficient';
  }
}
